"use client"

import type { IBiografiResult, ICreditedMovieSearchResult } from "src/lib/types/IBiografi";

import classNames from "classnames";
import { useState } from "react";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import styles from "./KinoDkFilmography.module.css";
import { locale } from "@locale";
import { getUrlForDoctype } from "src/lib/types/sanity";

//#region [Props]
type KinoDkFilmographyProps = {
    credits?: Omit<IBiografiResult, "biografi">;
};
//#endregion

//#region [Component]
export default function KinoDkFilmography({ credits }: KinoDkFilmographyProps) {
    if (!credits) {
        return null;
    }

    const actor = credits.films?.filter(f => f.isActor) ?? [];
    const director = credits.films?.filter(f => f.isDirector) ?? [];
    const voice = credits.films?.filter(f => f.isVoice) ?? [];

    return <div className={styles.Filmography}>
        <MovieRole credit={actor} isInitiallyExpanded={actor.length > 0} roleKey="actor" />
        <MovieRole credit={director} isInitiallyExpanded={actor.length === 0 && director.length > 0} roleKey="director" />
        <MovieRole credit={voice} isInitiallyExpanded={actor.length === 0 && director.length === 0 && voice.length > 0} roleKey="voice" />

    </div>;
}
//#endregion

type RoleKey = "actor" | "director" | "voice";

//#region [MovieRole]
function MovieRole({ credit, isInitiallyExpanded, roleKey }: { credit: ICreditedMovieSearchResult[] | null | undefined; isInitiallyExpanded: boolean; roleKey: RoleKey }) {
    const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);
    const [isShowingAll, setIsShowingAll] = useState(() => {
        if (isInitiallyExpanded && (credit?.length ?? 0) > 5) {
            return false;
        }
        return true;
    });

    if ((credit?.length ?? 0) === 0) {
        return null;
    }
    /*
    const movies = [...credit].sort((m1, m2) => {
        if (!m1.year && !m2.year) return 0;
        if (!m1.year) return 1;
        if (!m2.year) return -1;
        return m2.year.localeCompare(m1.year);
    })*/

    return <div className={styles.MovieRole}>
        <button className={classNames(styles.ButtonReset, styles.Expander, { [styles.IsExpanded]: isExpanded })} aria-controls={roleKey} onClick={() => setIsExpanded(!isExpanded)}><span>{locale.biografi[roleKey]}</span></button>
        <div className={classNames(styles.MoviesCollapsible, { [styles.IsExpanded]: isExpanded })}>
            <ol id={roleKey} className={classNames(styles.MoviesWithRole, { [styles.IsShowingAll]: isShowingAll })}>
                {credit?.map(movie => <Movie key={movie._id} movie={movie} />)}
            </ol>
        </div>
        {!isShowingAll && isExpanded && <button className={classNames(styles.ButtonReset, styles.ShowAllButton)} onClick={() => setIsShowingAll(true)}>Se flere</button>}
    </div>
}
//#endregion

//#region [Movie]
function Movie({ movie }: { movie: ICreditedMovieSearchResult | null | undefined }) {
    if (!movie) {
        return null;
    }

    const url = getUrlForDoctype(movie._type, undefined, false, movie);
    const year = movie.year?.toString() ?? movie.premiereOverride?.premiereDate?.substring(0, 4) ?? movie.premiere?.premiereDate?.substring(0, 4);

    return <li className={styles.Movie}>
        {url && <FilmwebLink className={styles.Link} to={url}>{movie.title} <span className={styles.MovieYear}>{year}</span></FilmwebLink>}
        {!url && <>{movie.title} <span className={styles.MovieYear}>{year}</span></>}
    </li>
}
//#endregion
